import type { AirworthyLog, Drone, DroneReadiness } from '../../types';

// Applies a manual airworthy override on top of a drone's auto-health readiness.
// The effective readiness is the override when present, otherwise the drone's own
// readiness. A matching override carries a fresh log; when no override exists the
// drone keeps any pre-seeded airworthyLog from mock data.
export const applyAirworthy = ({
    airworthyLogs,
    airworthyOverrides,
    drone
}: {
    airworthyLogs: Record<string, AirworthyLog>;
    airworthyOverrides: Record<string, DroneReadiness>;
    drone: Drone;
}): Drone => {
    const override = airworthyOverrides[drone.id];

    if (!override) {
        return drone;
    }

    return {
        ...drone,
        airworthyLog: airworthyLogs[drone.id] ?? drone.airworthyLog,
        readiness: override
    };
};
